import { createContext, ReactNode, useContext } from "react";
import { ContextType, DataProvider } from "./DataProvider";
import { PropSimulationHistory } from "../shared/types/PropSimulation";

const PropSimulationDataContext =
  createContext<ContextType<PropSimulationHistory> | null>(null);

export const PropSimulationDataProvider = ({
  children,
}: {
  children: ReactNode;
}) => (
  <DataProvider
    context={PropSimulationDataContext}
    collection="propsimulations"
    sort={{ createdAt: -1 }}
    limit={100}
    projection={{
      _id: 1,
      name: 1,
      createdAt: 1,
      storageVersion: 1,
      config: 1,
      strategyText: 1,
      summary: 1,
      profileSummaries: 1,
      typeSummaries: 1,
    }}
  >
    {children}
  </DataProvider>
);

export const usePropSimulationData = () => {
  const context = useContext(PropSimulationDataContext);
  if (!context) {
    throw new Error(
      "usePropSimulationData must be used within a PropSimulationDataProvider",
    );
  }
  return context;
};
